import Input from '../Input/Input';
import { SearchInputProps } from './SearchInput.types';
import '../../../styles/SearchInput.css';
import { InputLabelColor } from '../Input/Input.types';

export default ({
  suggestions,
  handleSelectedSuggestion = () => null,
  label,
  labelColor = InputLabelColor.Dark,
  error,
  required,
  ...props
}: SearchInputProps) => {
  return (
    <div className="input">
      <label
        htmlFor="input-label"
        className="input__label font-bold"
        style={{ color: labelColor === InputLabelColor.Light ? '#fff' : '#000' }}>
        {label} {required && <span style={{ color: 'red' }}>*</span>}
      </label>
      <div className="searchInput">
        <Input id='input-label' {...props} />
        {suggestions?.map((suggestion, suggestionIndex) => (
          <div
            key={suggestionIndex}
            data-testid='suggestion-item'
            className="searchInput__item"
            onClick={() => handleSelectedSuggestion(suggestion)}>
            <span>{suggestion.fullAddress}</span>
          </div>
        ))}
      </div>
      <span className="input__error">{error}</span>
    </div>
  );
};
